module.exports = __webpack_public_path__ + "img/MGH-Roppongi-2.bcdcb7d5.jpg";